//src/styles/palette/index.js
import { lighten, darken, alpha } from "@mui/material/styles";
import { generateVariants, getContrastText, getCSSVariable } from "../utils/colorUtils";

// Base colors from CSS variables
const primaryColor = getCSSVariable("--primary-color", "#4b0082");
const secondaryColor = getCSSVariable("--secondary-color", "#ffd47f");

// Static semantic colors
const errorColor = "#e53935";
const warningColor = "#ffb300";
const infoColor = "#1e88e5";
const successColor = "#43a047";

// Generate all color variants
const primary = generateVariants(primaryColor);
const secondary = generateVariants(secondaryColor);
const error = generateVariants(errorColor);
const warning = generateVariants(warningColor);
const info = generateVariants(infoColor);
const success = generateVariants(successColor);

// Background colors
const background = {
  default: alpha(lighten(primaryColor, 0.95), 0.7),
  alt: lighten(primaryColor, 0.9),
  paper: lighten(primaryColor, 0.95),
  surface: lighten(primaryColor, 0.85),
  highlight: lighten(secondaryColor, 0.4),
  elevated: lighten(secondaryColor, 0.95),
};

// Text colors
const text = {
  primary: darken(primaryColor, 0.1),
  secondary: primaryColor,
  tertiary: lighten(primaryColor, 0.2),
  hint: alpha(primaryColor, 0.6),
  disabled: alpha(primaryColor, 0.38),
  inverse: "#ffffff",
};

// Action colors
const action = {
  active: alpha(primary.main, 0.54),
  hover: secondary.alpha['20'],//15
  selected: background.highlight,
  disabled: text.disabled,
  disabledBackground: alpha(background.default, 0.5),
  focus: alpha(primaryColor, 0.4),
};

// Divider color
const divider = lighten(primaryColor, 0.8);

const palette = {
  mode: 'light',
  primary: { ...primary, contrastText: getContrastText(primary.main) },
  secondary: { ...secondary, contrastText: getContrastText(secondary.main) },
  error: { ...error, contrastText: "#ffffff" },
  warning: { ...warning, contrastText: "#1a1a1a" },
  info: { ...info, contrastText: "#ffffff" },
  success: { ...success, contrastText: "#ffffff" },
  background,
  text,
  action,
  divider,
  // Raw colors for custom use
  raw: {
    primary: primaryColor,
    secondary: secondaryColor,
    border: alpha(lighten(primaryColor, 0.7), 0.3),
  },
  // Utility colors
  utility: {
    border: alpha(lighten(primaryColor, 0.7), 0.3),
    divider: lighten(primaryColor, 0.8),
    shadow: `${primaryColor}26`,
    focus: alpha(primaryColor, 0.4),
  },
};

export default palette;